import { type MaybeComputedElementRef, unrefElement, useElementVisibility, useMutationObserver } from "@vueuse/core";
import type { GuidedSetupHomePromotion, SetupHomeCard } from "~vue/ProfileSetup/types";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { watch } from "vue";

export function guidedSetupHomeEventProps(card: SetupHomeCard, promotion?: GuidedSetupHomePromotion) {
    return {
        card_type: "coaching_setup",
        page: "home",
        coaching_setup_completed_count: card.completed_count,
        coaching_setup_step_count: card.total,
        coaching_setup_next_step: card.next_step,
        coaching_setup_home_presentation: !promotion || promotion.group === "control" ? "control_card" : promotion.presentation === "banner" ? "magic_banner" : "magic_card",
        ...(promotion && {
            card_interaction_count: promotion.interaction_count,
            card_offer_sequence_number: promotion.interaction_count + 1,
        }),
    };
}

export function useGuidedSetupHomeView(target: MaybeComputedElementRef, eventProps: () => ReturnType<typeof guidedSetupHomeEventProps>): void {
    const inViewport = useElementVisibility(target);
    let viewed = false;
    const trackView = () => {
        const element = unrefElement(target);
        if (viewed || !inViewport.value || !element || element.closest('[aria-hidden="true"], [inert]')) {
            return;
        }
        viewed = true;
        stopObserving();
        void logUserInteraction(AmplitudeEventNames.CARD_VIEWED, eventProps());
    };
    // Dialogs mark the covered page aria-hidden.
    const { stop: stopObserving } = useMutationObserver(globalThis.document?.body, trackView, {
        attributes: true,
        attributeFilter: ["aria-hidden", "inert"],
        subtree: true,
    });
    watch(inViewport, trackView);
}
